import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "masking-all-texts-and-images"
    }}>{`Masking All Texts and Images`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`final config = PostHogConfig('<ph_project_api_key>');
config.sessionReplay = true;
/// Enable masking of all text and text input fields.
/// Default: true.
config.sessionReplayConfig.maskAllTexts = false;
/// Enable masking of all images.
/// Default: true.
config.sessionReplayConfig.maskAllImages = false;
`}</code></pre>
    <h3 {...{
      "id": "masking-in-flutter"
    }}>{`Masking in Flutter`}</h3>
    <ul>
      <li parentName="ul">{`You can manually mark a Widget for masking using the `}<inlineCode parentName="li">{`PostHogMaskWidget`}</inlineCode>{` Widget:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`...
    const PostHogMaskWidget(child: Text('Sensitive!'))
...
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      